import React, { useContext } from "react";
import Link from "next/link";
// import { useRouter } from "next/router";

import { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Container from "react-bootstrap/Container";
import { colors } from "utils/styles";
import Text from "./Text";
import Title from "./Title";

import { parseDate, getArticleCardHref } from "utils/helpers";
import MarkdownContent from "components/Reusables/MarkdownContent";
import Image from "components/Reusables/Image";

export default function FeaturedArticle(props) {
	const { data } = props;
	const [FeaturedArticle, setFeaturedArticle] = useState(false);
	// const router = useRouter();

	if (!data?.productCollection || !data?.productCollection?.items?.length) {
		if (process.env.APP_ENV == "production") {
			return <></>; //don't show debug message in production
		}
		return <>No Product Collection</>;
	}

	useEffect(() => {
		function randomIntFromInterval(min, max) {
			// min and max included
			// return 5;
			return Math.floor(Math.random() * (max - min + 1) + min);
		}

		const count = data.productCollection.items.length;
		const rand = randomIntFromInterval(3, count - 4);
		//check if there is a featured article already specified
		const hasFeaturedArticle = data.productCollection.items.filter((item) => item.featured)[0];

		let FeaturedArticle = hasFeaturedArticle
			? hasFeaturedArticle
			: data.productCollection.items[rand] || data.productCollection.items[data.productCollection.items - 1];
		if (!FeaturedArticle || !FeaturedArticle.bannerImage) {
			console.error("No FeaturedArticle");
			FeaturedArticle = data.productCollection.items[0];
			// return <></>;
		}
		setFeaturedArticle(FeaturedArticle);
	}, [data]);
	if (!FeaturedArticle) {
		return <></>;
	}

	const { title, summary, publicationDate, canonicalUrl, primaryTag, secondaryTag, tertiaryTag, bannerImage } =
		FeaturedArticle;

	let { width, height, url } = bannerImage;
	url = url.replace("https:", ""); //gQl vs CDN mess
	// const imgAlt = bannerImage?.description;//this images never have a description

	let formattedPublicationDate;
	if (publicationDate) {
		const pubDate = parseDate(publicationDate);
		formattedPublicationDate = `${pubDate.fullMonthName} ${pubDate.dayOfMonth}, ${pubDate.year}`;
	}

	return (
		<div className="outerWrapper container-fluid  p-4">
			<div className=" innerWrapper container-lg g-0">
				<Row className="g-0 flex-column-reverse flex-md-row">
					<Col sm={12} md={6}>
						{/* border left */}
						<div className="border-left">
							<Row className="g-0">
								{/* Title */}
								<Col xs={11}>
									<Link href={getArticleCardHref(FeaturedArticle)}>
										<Title text={title} element="h2" color={colors["darkBlue"]} />
									</Link>
								</Col>
								{/* Pub. Date */}
								<Col xs={11}>
									<Text
										className="pe-2"
										size="12px"
										text={formattedPublicationDate}
										marginBottom="10px"
									/>
								</Col>
								{/* Summary */}
								<Col xs={11}>
									<MarkdownContent
										markdown={summary.length > 250 ? `${summary.slice(0, 250)}...` : summary}
									/>
									{/* <Text className="pe-2" size="16px" text={summary} marginBottom="0px" /> */}
								</Col>
							</Row>
						</div>
					</Col>
					<Col className="justify-content-center align-items-center  d-inline-flex mb-3" sm={12} md={6}>
						{/* Image */}
						<Image
							fields={{
								media: {
									fields: {
										description: summary,
										file: { url, details: { image: { width, height } } },
									},
								},
							}}
							extraClass="boxShadow d-inline-flex"
							maxHeight={400}
							alignImage="center"
						/>
					</Col>
				</Row>
			</div>

			<style jsx="true">{`
				.outerWrapper {
					background: ${colors.lightGray};
					min-height: 300px;
				}

				.innerWrapper {
					background: ${colors.lightGray};
					min-height: 300px;
				}

				.border-left {
					padding-top: 1em;
					padding-bottom: 1em;
					border-left: 3px solid ${colors.darkBlue};
					padding-left: 2em;
					border-radius: 10px;
					z-index: 10;
				}
			`}</style>
		</div>
	);
}
